import store from "utils/store.js";

export default function setEvent(eventId) {
  store.dispatch({
    type: "event/set",
    payload: eventId,
  });
}
